import * as React from "react";
import { Tabs } from "antd";
import Box from "@mui/material/Box";
import RightOfUseAssetReport from "../Right of use Asset Report/RightOfUseAssetReport";
import RightOfUseAssetSummaryReport from "../Right of use Asset Summary Report/RightOfUseAssetSumReport";
import ROUExhaustedAssetReport from "../Exhausted ROU Report/AssetSumReport";
import "./style.scss";
import { Helmet } from "react-helmet-async";
import LocationRightOfUseAssetSummaryReport from "../Branches Right Of Use Summary Report/LocationROUSummaryReport";

export default function RightOfUseReport() {
  const items = [
    { key: "1", label: "Asset Report", children: <RightOfUseAssetReport /> },
    {
      key: "2",
      label: "Summary Report",
      children: <RightOfUseAssetSummaryReport />,
    },
    {
      key: "3",
      label: "Location Report",
      children: <LocationRightOfUseAssetSummaryReport />,
    },
    {
      key: "4",
      label: "Exhausted Report",
      children: <ROUExhaustedAssetReport />,
    },
  ];

  return (
    <Box>
      <Helmet title='Right-of-use Report | Assets Register' />

      <Tabs items={items} defaultActiveKey='1' type='card' />
    </Box>
  );
}
